import {Brain, Heart, RotateCcw} from '@nlabs/gothamjs/icons';

import type {ReactElement} from 'react';

const portrait = new URL('../../assets/harbor-character-concept.png', import.meta.url).href;

export const MemoryDiagram = (): ReactElement => (
  <div className="memory-map">
    <header className="memory-character"><img alt="Ari at the harbor" loading="lazy" src={portrait} /><div><span>CHARACTER CONTINUITY · CONCEPT</span><h3>Ari remembers.</h3><p>The same encounter feels different because of what came before.</p></div></header>
    <div className="memory-context">
      <section className="memory-record"><span><Brain aria-hidden="true" size={16} /> STORED MEMORY</span>
        <h4>“You said you would come back.”</h4>
        <p>His friend left without saying goodbye. Ari waited at the dock.</p>
        <dl>
          <div><dt>Belief</dt><dd>Promises are fragile.</dd></div>
          <div><dt>Unresolved</dt><dd>Why did they leave?</dd></div>
        </dl>
      </section>
      <section className="memory-trigger"><span>NEW SCENE · THE TRIGGER</span>
        <h4>A familiar boat returns.</h4>
        <p>Ari recognizes his friend aboard. The sight recalls the departure.</p><div className="memory-emotions"><Heart aria-hidden="true" size={16} /><span>Hope at their return</span><span>Hurt from the past</span></div><p className="memory-choice">He approaches, but keeps his distance.</p>
      </section>
    </div>
    <div className="memory-branch-label">WHAT HAPPENS NEXT CHANGES WHAT HE CARRIES FORWARD</div>
    <div className="memory-branches">
      <section>
        <span>IF THEY ACKNOWLEDGE THE HURT</span>
        <h4>Trust begins to return.</h4>
        <p>Ari listens. In the next scene, he is more willing to help.</p>
      </section>
      <section>
        <span>IF THEY DISMISS IT</span>
        <h4>His guard goes up.</h4>
        <p>Ari withdraws. The next conversation starts with more distance.</p>
      </section>
    </div>
    <p className="memory-feedback"><RotateCcw aria-hidden="true" size={16} /><span>The encounter becomes a new memory, shaping their relationship and the next scene.</span></p>
  </div>
);
